export enum LangEnum {
    AR = 'ar',
    CA = 'ca',
    DE = 'de',
    EL = 'el',
    EN = 'en',
    ES = 'es',
    EU = 'eu',
    FR = 'fr',
    HR = 'hr',
    ID = 'id',
    IT = 'it',
    JA = 'ja',
    KO = 'ko',
    LV = 'lv',
    OC = 'oc',
    PL = 'pl',
    PT = 'pt',
    RO = 'ro',
    RU = 'ru',
    SL = 'sl',
    SV = 'sv',
    TH = 'th',
    TR = 'tr',
    VI = 'vi',
    ZH_SIMPLIFY = 'zh-Hans',
    ZH_TRADITIONAL = 'zh-Hant',
}
